import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";

const FormContainer = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 0px 5px #ccc;
  border-radius: 5px;
`;

const FormContainer2 = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 0px 5px #ccc;
  border-radius: 5px;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 100px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const InputId = styled.input`
  width: 30px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const Label = styled.label``;

const Button = styled.button`
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #2c73d2;
  color: white;
  height: 42px;
`;

const Select = styled.select`
  width: 120px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
  background-color: #fff;
`;

const FormTimes = ({ getUsers, onEdit, setOnEdit }) => {
  const ref = useRef();

  const [usuarios, setUsuarios] = useState([]);

  const [times, setTimes] = useState([]);
  const [nomeCartola, setNomeCartola]= useState([]);
  const [timeId, setTimeId]= useState([]);

  useEffect(() => {
    const loadStatusOptions = async () => {
      try {
        const response = await api.get("/liga/listarUsuarios"); // Exemplo de endpoint
        setUsuarios(response.data);
       
      } catch (error) {
        console.error("Erro ao buscar status:", error);
      }
    };
  
    loadStatusOptions();
  }, []);

  useEffect(() => {
    if (onEdit) {
      const user = ref.current;

      user.id.value = onEdit.id;
      user.nome.value = onEdit.nome;
      //user.idUsuario.value = onEdit.idUsuario;
      user.idCartola.value = onEdit.idCartola;
      user.escudo.value = onEdit.escudo;
      user.usuarios.value = onEdit.idUsuario; // <-- Aqui! seleciona no select
      //user.status.value = onEdit.status ?? "ativo"; // Se existir o status no objeto de edição
    }
  }, [onEdit]);

  const handleBuscaNoCartola = async (e) => {

    const user = ref.current;

    var usuario = user.nome.value;

    try {
      const res = await api.get("Cartola/buscarTime/" + usuario);
      setTimes(res.data)
      
    } catch (error) {
      toast.error(error.message);
    }

  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = ref.current;

    if (!user.nome.value || !user.idCartola.value) {
      return toast.warn("Preencha todos os campos!");
    }

    var resp = {
      id: Number(user.id ? user.id.value : 0),
      idUsuario: Number(user.usuarios ? user.usuarios.value : 0),
      nome: user.nome.value,
      idCartola: timeId, //user.idCartola.value,
      escudo: user.escudo.value,
      ativo: true //user.status.value === "ativo", // Transformando a escolha em boolean
    };

    console.log(resp);

    await api.post("liga/addTime", resp)
      .then(({ data }) => toast.success(data))
      .catch(({ data }) => toast.error(data));

    user.id.value = "";
    user.nome.value = "";
    //user.idUsuario.value = "";
    user.idCartola.value = "";
    user.escudo.value = "";
    //user.status.value = "ativo";

    setOnEdit(null);
    getUsers();
  };

   function handleSelectTimeCartola(event) {
  
      var valor = event.target.value

      const index = valor.indexOf("|"); 

     const nomeCartola = valor.substring(0,index-1); // substring will be "sample string"

     setNomeCartola(nomeCartola)

     const timeId = valor.substring(index+2, index+10); 

     setTimeId(timeId)
      
  
     // console.log(valor.substring(index))
      //console.log(timeId)
  
     /* const idMovimento = Number(event.target.value);
      setMovimentoSelecionado(idMovimento);
    
      if (idMovimento === 1) {
        // Entrada - só descrição com id=1
        const desc = descricao.filter(d => d.id === 1);
        setDescricaoFiltrada(desc);
      } else if (idMovimento === 2) {
        // Saída - descrição com id=2 e id=3
        const desc = descricao.filter(d => d.id === 2 || d.id === 3 || d.id === 4);
        setDescricaoFiltrada(desc);
      } else {
        setDescricaoFiltrada([]);
      }*/
    }
    

  return (
    <>
    <FormContainer ref={ref} onSubmit={handleSubmit}>
      <InputArea>
        <Label>Id</Label>
        <InputId name="id"/>
      </InputArea>
      <InputArea>
        <Label>Nome</Label>
        <Input name="nome" />
      </InputArea>
      <InputArea>
        <Label>Cartoleiro</Label>
        <Input name="idCartola" />
      </InputArea>
      
      <InputArea>
        <Label>Escudo</Label>
        <Input name="escudo" />
      </InputArea>
      
      <InputArea>
        <Label>Usuário</Label>
        <Select name="usuarios">
          <option value="">Selecione</option>
          {usuarios.map((usuario) => (
            <option key={usuario.id} value={usuario.id}>
              {usuario.nome}
            </option>
          ))}
        </Select>
      </InputArea>

      <Button type="submit">Salvar Time</Button>
    </FormContainer>

    <FormContainer2>
      <Button onClick={handleBuscaNoCartola}>Buscar no Cartola</Button>

      <InputArea>
        <Label>Lista de times</Label>
        <Select name="times" onChange={(usuario) => handleSelectTimeCartola(usuario)}>
          <option value="">Selecione</option>
          {times?.map((usuario) => (
            <option key={usuario.time_id} >
              {usuario.nome} | {usuario.time_id} | {usuario.nome_cartola}
            </option>
          ))}
        </Select>
      </InputArea>

      <InputArea>
        <Label>Nome no Cartola</Label>
        <Input value={nomeCartola} />
      </InputArea>

      <InputArea>
        <Label>IdCartola</Label>
        <Input  value={timeId} />
      </InputArea>

    </FormContainer2>

    </>
  );
};

export default FormTimes;
